import { Text, View, StyleSheet, Link } from '@react-pdf/renderer';
import { InitialPallets, Report } from "../../interfaces/intakes.reports"
import { pallgrowDefects } from '../../helpers/defectsTable';
import { globalStyles } from './DocuPdf';
import { DataBox } from './DataBox';

interface Props {
  pallet: InitialPallets
  data: Report
  index: number
}

interface SummaryItemProps {
  label: string
  value: string
  isDefect?: "major" | "minor"
}

export const PDFPalletsSummary = ({ pallet, data, index }: Props) => {

  const { major, minor, totalMajor, totalMinor, totalDefects } = pallgrowDefects(pallet.pallgrow.data, (pallet.pallgrow.major || []), (pallet.pallgrow.minor || []))

  const formatGr = pallet.pallgrow.data.find(item => item.name === "format_gr")?.value
  const variety = pallet.labels.data.find(item => item.name === "variety")?.value
  const pallet_reference = pallet.labels.data.find(item => item.name === "pallet_reference")?.value
  // const weight_format = Number(pallet.details?.pallgrow.find(item => item.name === "weight_10")?.valor || 0)


  const SummaryItem = ({ label, value, isDefect }: SummaryItemProps) => {
    return (
      <View style={[globalStyles.flexRow, { justifyContent: 'center', gap: 4 }]}>
        <Text style={{ width: '50%', fontSize: '8px', textAlign: "right", color: '#6b7280' }}>{label}: </Text>
        <Text style={[globalStyles.bold, { fontSize: '8px' }, isDefect ? { color: isDefect === "major" ? "red" : "orange" } : { color: "#353644" }]}>{value}</Text>
      </View>
    )
  };

  return (

    <View style={[globalStyles.flexRow, { alignItems: 'flex-start', paddingVertical: 2, borderTopColor: '#dcdcdc', borderTopWidth: .5 }]}>
      {/* <Link src={`#pallet-${index}`} style={[globalStyles.flexRow, { width: '25%', alignItems: 'center' }]}>
        <Text style={[globalStyles.bold, { marginRight: 5, fontSize: "10px", color: "#353644" }]}>{pallet.pallet_sample ? "Sample" : "Pallet"}</Text>
        <Text style={[globalStyles.bold, { fontSize: "10px", color: "#353644" }]}>{pallet.pallet_sample ? pallet.pallet_sample : (pallet.pallet || index+1)}</Text>
      </Link> */}
      <Link src={`#pallet-${index}`} style={[{ width: '25%'}]}>
        <View style={[globalStyles.flexRow, { alignItems: 'center' }]}>
          <Text style={[globalStyles.bold, { marginRight: 5, fontSize: "10px", color: "#353644" }]}>{pallet.pallet_sample ? "Sample" : "Pallet"}</Text>
          <Text style={[globalStyles.bold, { fontSize: "10px", color: "#353644" }]}>{pallet.pallet_sample ? pallet.pallet_sample : pallet.pallet}</Text>
        </View>
        {
          pallet_reference &&
          <Text style={{ fontSize: "7px", color: "#6b7280" }}>{pallet_reference}</Text>
        }
      </Link>



      <View style={[{ width: '25%', alignItems: 'flex-start', flexDirection: 'column' }]}>
        <SummaryItem label="product" value={data.fruit || "--"} />
        <SummaryItem label="quality" value={data.mainData.quality || "--"} />
        <SummaryItem label="variety" value={variety || data.mainData.variety || "--"} />
      </View>

      <View style={[{ width: '25%', alignItems: 'flex-start', flexDirection: 'column' }]}>
        <SummaryItem label="weight" value={formatGr ? `${formatGr} gr` : "--"} />
        <SummaryItem label="major defects" value={totalMajor ? `${totalMajor}%` : "--"} isDefect='major' />
        <SummaryItem label="minor defects" value={totalMinor ? `${totalMinor}%` : "--"} isDefect='minor' />
      </View>

      <DataBox pallet={pallet} date={new Date()} />
    </View>

  )
}

export const styles = StyleSheet.create({

  colorMajor: { color: "red" },
  colorMinor: { color: "orange" },
})
